import React, { Component } from "react";
import Loading from "./loader";
import ChangePassword from "./ChangePassword";


class User_Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: '',
      showDemoTwoModal: false,
    };
  }

  async componentDidMount() {
    try {
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
      const res = await fetch(`${API_ADDRESS}settings/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        }
      });

      const answer = await res.json();
      if (answer["detail"] === "Signature has expired.") {
        alert("Время сессии истекло. Пожалуйста выполните вход.");
        document.getElementById("logoutBttn").click();
      } else {
        this.setState({
          data: answer
        });
      }

      // Проверяем значение openModalOnRedirect
      const openModalOnRedirect = localStorage.getItem("openModalOnRedirect");
      if (openModalOnRedirect === "true") {
        this.setState({ showDemoTwoModal: true });
        localStorage.removeItem("openModalOnRedirect");
      }
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    var key = this.state.data[0];
    if (key !== undefined) {
      return (
          <div className="page-container">
            <div className="wrapper1 holder middleForm">
              <div>
                <label className="shadow"> Номер телефона </label>
              </div>
              <div>
                <input type="text" className="main-input10" readOnly
                       value={JSON.parse(this.state.data)[0]['username']}/>
              </div>
              <div>
                <label className="shadow"> Email </label>
              </div>
              <div>
                <input type="text" className="main-input10" readOnly value={JSON.parse(this.state.data)[0]['email']}/>
              </div>

              <div>
                <ChangePassword style={''}/>
              </div>
            </div>
          </div>
      );
    } else {
      return (
          <Loading/>
      );
    }
  }
}

export default User_Profile;
